import { LoginFormQuery } from "$relay/LoginFormQuery.graphql"
import { useContext } from "react"
import { View } from "react-native"

import { AppContext } from "../../../AppContext"
import { ModalForm } from "../DesignSystem"
import { GhostLoadingUserSelectorAvatar, UsersSelector } from "../profiles/UsersSelector"
import { AuthModalContext } from "./AuthModal"

export function UserSelectorForm(props: {
  usersOnAccount: number
  email: string
  password: string
  users: LoginFormQuery["response"]["usersOnAnAccount"]
}) {
  const { users, email, password, usersOnAccount } = props
  const ctx = useContext(AppContext)
  const modalCtx = useContext(AuthModalContext)

  const selectedUser = async (username: string) => {
    await ctx.apiClient.login(email, password, username)
    if (ctx.apiClient.authed()) {
      modalCtx.closeModal()
    } else {
      console.log("not logged in?")
    }
  }

  return (
    <View>
      <ModalForm.Title>Select profile</ModalForm.Title>
      {users && <UsersSelector users={users} selectedUser={selectedUser} isShowingInDarkModal />}
      {!users.length && <GhostLoadingUserSelectorAvatar count={usersOnAccount} />}
    </View>
  )
}
